import { UiControl } from './ui-control.model';
import { BaseControlOption } from '../control-options/control-option.interface';

export class TextControl extends UiControl<string> {

  constructor(id: string, label: string, value: string, ... options: BaseControlOption[]) {
    super(id, label, value, false, options);
    this.className = "TextControl";
  }

}
